<template>
  <section>
    <hero/>
    <main-body>
      <router-view/>
    </main-body>
  </section>
</template>

<script>
import MainBody from '../../core/components/MainBody'
import Hero from './Hero'

export default {
  name: 'standardPage',
  components: {
    Hero,
    MainBody,
  },
}
</script>
<style>
.body-restrict {
  width: 95%;
  max-width: 1200px !important;
}
</style>
